
function Navigation() {
  return (
    <nav class="footer-container__menu">
      <ul class="footer-container__menu-list">
        <li>
          <a class="footer-container__link" href="#skills">
            Чему вы научитесь
          </a>
        </li>
        <li>
          <a class="footer-container__link" href="#description">
            Процесс обучения
          </a>
        </li>
        <li>
          <a class="footer-container__link" href="#price">
            Стоимость
          </a>
        </li>
       
      </ul>
    </nav>
  );
}

export default Navigation;
